import { saveResendLinkActions } from "./action";

const initialState = {
  resendLinkData: null,
};

const saveResendLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveResendLinkActions.SAVE_RESEND_LINK_DETAILS_SUCCESS:
      return {
        ...state,
        resendLinkData: action.payload,
      };
    case saveResendLinkActions.SAVE_RESEND_LINK_DETAILS_SUCCESS:
      return {
        ...state,
        resendLinkData: [],
      };
    default:
      return state;
  }
};

export default saveResendLinkReducer;
